/* v1.0.52 : alerte retour en stock
   - après le contrôle anti-robot, la taille demandée est de nouveau sélectionnée (et non la 1re taille en stock) ;
   - adresse vérifiée avant l'envoi (ex. « prenom.@domaine.fr » refusée par Shopify, qui renvoyait alors
     sur l'accueil après le contrôle anti-robot sans rien enregistrer) : message clair sous le champ ;
   - consentement marketing : le formulaire client de Shopify n'enregistre rien si contact[accepts_marketing]
     n'est pas « true » (tests du 27/09 : champ absent ou « false » → retour à l'accueil, aucune fiche).
     Le champ reste donc à « true » (Liquid) et la mention sous le champ l'annonce clairement (product.json) ;
   - taille rappelée dans la confirmation après le contrôle anti-robot : mémorisée dans sessionStorage
     (v1.0.47 modifiait return_to, ce qui renvoyait sur l'accueil après la vérification : abandonné) ;
   - envoi sans rechargement ; la confirmation n'est affichée que si Shopify confirme l'enregistrement
     (redirection vers ?restock=ok ou ?customer_posted=true). Sinon (contrôle anti-robot, erreur),
     on repasse par l'envoi classique pour que la cliente voie ce que Shopify demande ;
   - la cliente est enregistrée dans Clients avec les étiquettes restock et restock:produit:variante:taille
     (y compris une cliente déjà enregistrée) ; l'e-mail d'avertissement à la boutique est envoyé par
     Shopify Flow (« Étiquettes de client ajoutées » → « Envoyer un e-mail interne »), voir README ;
*/
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var box = document.querySelector('[data-restock]'); if (!box) return;
    var form = box.querySelector('form'), done = box.querySelector('[data-restock-done]');
    if (!form || !done) return;

    function label() {
      var t = document.querySelector('[data-product] h1'), v = box.querySelector('[data-restock-variant]');
      var size = v ? v.textContent.trim().replace(/^\((.*)\)$/, '$1') : '';
      return { name: t ? t.textContent.trim() : 'ce modèle', size: size };
    }
    function showDone(sizeOverride) {
      var l = label(), nm = box.querySelector('[data-restock-name]');
      var size = typeof sizeOverride === 'string' && sizeOverride ? sizeOverride : l.size;
      if (nm) nm.textContent = l.name + (size ? ' (taille ' + size + ')' : '');
      form.hidden = true; done.hidden = false; box.hidden = false;
      done.setAttribute('role', 'status');
    }

    /* options choisies (taille, couleur…) : mémorisées avant l'envoi classique, resélectionnées au retour */
    var root = form.closest('[data-product]') || document;
    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('fieldset[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function restoreOptions(opts) {
      Array.prototype.forEach.call(root.querySelectorAll('fieldset[data-option]'), function (fs, i) {
        if (!opts[i]) return;
        Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) {
          if (r.value === opts[i] && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
    }

    /* retour de l'envoi classique (après contrôle anti-robot) */
    var q = new URLSearchParams(location.search);
    if (q.get('customer_posted') === 'true' || !done.hidden) { /* !done.hidden : confirmation déjà ouverte par theme.js (?restock=ok) */
      var saved = null; try { saved = JSON.parse(sessionStorage.getItem('mwtRestock') || 'null'); sessionStorage.removeItem('mwtRestock'); } catch (err) {}
      if (saved && saved.opts) restoreOptions(saved.opts);
      showDone(saved && saved.size ? saved.size : '');
    }

    /* adresse e-mail : même exigence que Shopify (pas de point en début/fin de nom, ni de points doubles) */
    var emailField = form.querySelector('[name="contact[email]"]');
    function emailOk(v) {
      v = (v || '').trim();
      var at = v.lastIndexOf('@'); if (at < 1) return false;
      var local = v.slice(0, at), dom = v.slice(at + 1);
      if (/^\.|\.$|\.\./.test(local) || /\s/.test(v)) return false;
      return /^[^\s@]+\.[a-z]{2,}$/i.test(dom) && !/\.\./.test(dom);
    }
    if (emailField) emailField.addEventListener('input', function () { emailField.setCustomValidity(''); });

    var nativeNext = false;
    form.addEventListener('submit', function (e) {
      if (nativeNext) return; /* envoi classique : on laisse passer (et la protection anti-robot de Shopify) */
      e.preventDefault();
      if (emailField && !emailOk(emailField.value)) {
        emailField.setCustomValidity("Cette adresse e-mail n'est pas valide. Vérifiez-la (par exemple, pas de point juste avant @).");
        emailField.reportValidity();
        return;
      }
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      function post(fd) { return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } }); }
      post(new FormData(form))
        .then(function (r) {
          window.__mwtRestock = { status: r.status, url: r.url, redirected: r.redirected };
          if (!r.ok || !/[?&](restock=ok|customer_posted=true)/.test(r.url)) throw new Error('not-confirmed');
        })
        .then(function () { showDone(); })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          try { sessionStorage.setItem('mwtRestock', JSON.stringify({ size: label().size, opts: currentOptions() })); } catch (err) {}
          nativeNext = true;
          if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
        });
    });
  });
})();
